import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import './ListPage.css';

const API_BASE = process.env.REACT_APP_API_URL || 'https://saskararecord.com/api';

const STATUS_LABEL = { upcoming: 'Segera', sold_out: 'Sold Out', past: 'Selesai' };

function formatDate(dateStr) {
  const d = new Date(dateStr);
  return d.toLocaleDateString('id-ID', { day: 'numeric', month: 'long', year: 'numeric' });
}

export default function EventsList() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${API_BASE}/events`)
      .then((res) => setEvents(res.data.data || res.data || []))
      .catch(() => setEvents([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="list-page">
      <nav className="list-page__nav">
        <Link to="/" className="list-page__back">← Beranda</Link>
      </nav>

      <h1 className="list-page__title">Semua Event</h1>

      {loading ? (
        <p className="list-page__empty">Memuat...</p>
      ) : events.length === 0 ? (
        <p className="list-page__empty">Belum ada event.</p>
      ) : (
        <div className="list-page__grid">
          {events.map((ev) => (
            <Link to={`/events/${ev.id}`} className="list-card" key={ev.id}>
              <div className="list-card__photo list-card__photo--tall">
                {ev.poster_url ? (
                  <img src={ev.poster_url} alt={ev.title} />
                ) : (
                  <div className="list-card__photo-fallback" />
                )}
                <span className={`list-card__badge list-card__badge--${ev.status}`}>
                  {STATUS_LABEL[ev.status] || ev.status}
                </span>
              </div>
              <div className="list-card__body">
                <p className="list-card__date">{formatDate(ev.event_date)} · {ev.city}</p>
                <h3 className="list-card__title">{ev.title}</h3>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
